import React from 'react';
import { RichContent } from '../elements/RichContent';
import BackButton from '../../../common/elements/BackButton';

export const CorporateInfoComponent = props => {
	const { corporateInfo } = props.content;

	return (
		corporateInfo && (
			<div className="container">
				<div className="row">
					<div className="col-12 corporate-back-button">
						<BackButton />
					</div>
					<section className="kiwi-info__corporate">
						<div className="container">
							<div className="row">
								<div className="col-xs-12">
									<RichContent dangerous={corporateInfo} />
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		)
	);
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/CorporateInfoComponent.js